import { environment } from '../../../environments/environment';
export class VMSConstants {

  public static nameValidator = /^[A-Za-z0-9\. \'-]+$/;
  public static emailValidator = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  //public static phoneNumberValidator = /^[0-9\(\)-]{13}$/;
  public static phoneNumberValidator = "^(\\([0-9]{3}\\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$";
  public static ssnValidator = /^[0-9-]{11}$/;
  public static dateValidator = /^(3[0-1]|2[0-9]|1[0-9]|0[1-9])[\/](Jan|JAN|Feb|FEB|Mar|MAR|Apr|APR|May|MAY|Jun|JUN|Jul|JUL|Aug|AUG|Sep|SEP|Oct|OCT|Nov|NOV|Dec|DEC)[\/]\d{4}$/;
  public static maxPhoneLength = 13;
  public static nameMaxLength = 150;
  public static emailMaxLength = 300;
  public static gridDefaultPageLength = 10;
  public static passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  public static dashboardDateformat = 'dd-MMM-yyyy HH:mm:ss';
  public static expValidator = /^(\d{1,2})(\.([1-9]|1[0-1]))?$/;
   //public static hourlyBillRateValidator = /^([1-9]|[1-9][0-9])(\.\d{1})?$/;
   //public static hourlyBillRateValidator =/\d\d+\.\d\d(?!\d)/;
  public static hourlyBillRateValidator =/^((?!(0))[0-9]{1,3})(\.\d{1,2})?$/;
  public static zipcodeValidator = /\b\d{5}\b/;
  public static zipcodeExtValidator = /\b\d{4}\b/;
  public static phoneExtValidator = /^[0-9]{1,6}$/;
  public static onshorePhone = /^[0-9]{1,6}$/;
  public static urlRegex = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  public static taxIdValidator = /^[0-9\(\)-]{10}$/;
  public static emailValidatorBusiness = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(!gmail|!yahoo|!hotmail|!hubspot|!sendinblue|!protonmail|!outlook|!zoho|!aol|!mail|!gmx|!icloud|!yandex)\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  public static emailValidatorIndiviual = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(gmail|yahoo|hotmail|hubspot|sendinblue|protonmail|outlook|zoho|aol|mail|gmx|icloud|yandex)\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  public static repeatingNumberValidator = /\b(\d)\1+\b/;
  //public static revenueValidator =/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;
   //public static revenueValidator =/^\-?[0-9]+(?:\.[0-9]{2})?$/;
   public static revenueValidator =/^((?!(0))[0-9]{1,12})(\.\d{1,2})?$/;
   public static noZeroValidator=/^[1-9][0-9]*([.][0-9]{1,2})*$/;
   public static amountValidator=/^-?[0-9][0-9]*([.][0-9]{1,2})*$/;
   public static numericFilterValidator= /^-?[0-9][0-9]*([.][0-9]{1,2})*$/;
   public static linkValidator = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  //withnumbers  public static applicantNameValidator = /^(?![0-9!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?])(.{2,})$/;
  public static applicantNameValidator = /^[a-zA-Z\s][a-zA-Z!@#$%^&*()_+={}\[\]\\|:;"'<>,.?\/\s-]{1,}$/;


   public static applicantDocumentBaseUrl =  `${environment.downloadUrl}` + 'applicant-document-files/';
   public static invoiceDocumentBaseUrl = `${environment.downloadUrl}` + 'invoice-document-files/';
   public static requisitionDocumentBaseUrl = `${environment.downloadUrl}` + 'requisition-document-files/';
   public static registrationDocumentBaseUrl = `${environment.downloadUrl}` + 'vendor-document-files/';
   public static tempDocumentBaseUrl = `${environment.downloadUrl}` + 'vendor-document-files';
   public static companyDocumentBaseUrl = `${environment.downloadUrl}` + 'company-document-files/';
   public static editiorImageBaseUrl = `${environment.downloadUrl}` + 'text-editior-images/';
   public static improvementsBaseUrl = `${environment.downloadUrl}` + 'dvms-improvement-documents/';
   public static vendorOnboardingDocumentBaseUrl = `${environment.downloadUrl}` + 'vendor-onboarding-document-files/';

  //  public static applicantDocumentBaseUrl = 'https://dvmsprod.blob.core.windows.net/applicant-document-files/';
  //  public static invoiceDocumentBaseUrl = 'https://dvmsprod.blob.core.windows.net/invoice-document-files/';
  //  public static requisitionDocumentBaseUrl = 'https://dvmsprod.blob.core.windows.net/requisition-document-files/';
  //  public static registrationDocumentBaseUrl = 'https://dvmsprod.blob.core.windows.net/vendor-document-files/';
  //  public static editiorImageBaseUrl = 'https://dvmsprod.blob.core.windows.net/text-editior-images/';
  //  public static companyDocumentBaseUrl = 'https://dvmsprod.blob.core.windows.net/company-document-files/';

   public static editorModule = {
    toolbar: [   
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
      [{ 'font': [] }],   
      ['bold', 'italic', 'underline', 'strike'], 
      [{ 'color': [] }, { 'background': [] }], 
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link']
    ]
  }
   
}


export enum UserRoles {
  SuperAdmin =1,
  Admin,
  VMSAnalyst,
  Guest,
  VendorAdmin ,
  VendorAccount,
  VendorUser,
}